export interface UserModel {
  id: string;
  authId: string;
  email: string;
  name: string;
  role: Role;
  country?: string;
  parentAuthId: string;
  subRoles: Array<string>;
  isSubUser: boolean;
  twoFactorEnabled: boolean;
}

export enum Role {
  SUPER_ADMINISTRATOR = 'superadministrator',
  SERVICE_PROVIDER = 'serviceprovider',
  CLIENT = 'client'
}

export enum SubRole {
  ADMINISTRATOR = 'administrator',
  FINANCE = 'finance and account',
  SUPPORT = 'support'
}